import 'promise-polyfill/src/polyfill'
import './polyfills'
import 'intersection-observer'

import './assets'

import { createComponent } from '@bigyouth/base'

import 'lazysizes'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks' // lazyload bgs with data-bg
import objectFitImages from 'object-fit-images'

import './style/styles-global.scss'
import * as features from './features/exports/global'

objectFitImages()

Object.values(features).forEach(createComponent)

// remove preload class on body (prevent flash of transitions when page is loading)
document.addEventListener('DOMContentLoaded', function () {
  document.body.classList.remove('preload')
})
